import { memoize } from 'lodash';


export default memoize(function loadScript(url) {
    return new Promise(resolve => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => {
            setTimeout(resolve, 10);
        };
        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/load-script.js